module.exports = __webpack_public_path__ + "static/media/simple-icon-modal.158afac4.webp";